// src/api/heroApi.js
import { heroMockData } from "./mock/heroData";

export const getDataByAll = () => {
  return new Promise((resolve) => {
    // Simulasi delay API 500ms
    setTimeout(() => {
      resolve(heroMockData);
    }, 500);
  });
};